import Chip from "@mui/material/Chip";

export default function DefaultChip() {
  return (
    <Chip
      size="small"
      sx={{
        fontSize: "0.65rem",
        height: "18px",
        ml: 1,
      }}
      label={"Default"}
      // color={"primary"}
      variant="filled"
    />
  );
}
